import  {Component} from "react";
import {Button, Layout, message} from "antd";
import {EnterOutlined,FolderOpenOutlined} from "@ant-design/icons";
import NavHeader from "../../components/NavHeader";
import SiderMenuMain from "../../components/SiderMenuMain";
import NavFooter from "../../components/NavFooter";
import React from "react";
import AxiosUtil from "../../utils/AxiosUtil";
import moment from "moment";
import ReactDOM from "react-dom";
import EditableTable from "../../components/EditableTable";
import NavBreadcrumb from "../../components/NavBreadcrumb";

const {Content} = Layout;

interface IProps {
}

export default class Param extends Component<IProps> {

    state = {
        parents: [0],
        mainData: [],
    }

    componentDidMount() {
        //组件加载完成后触发
        this.reload();
    }
    reload = () => {
        const query = {parent_id: this.state.parents[this.state.parents.length - 1]};
        AxiosUtil.AxiosRequest('/api/param/list', query, this.loadMainData);
    }
    reloadChildren = (param_id: number) => {
        const p = this.state.parents;
        p.push(param_id);
        this.setState({parents: p})
        this.reload();
    }
    reloadParent = () => {
        if (this.state.parents.length > 1) {
            const p = this.state.parents;
            p.pop();
            this.setState({parents: p})
            this.reload();
        }
    }
    render() {

        const crumb = [
            {name: '系统管理'},
            {name: '参数设置'},
        ];
        return (
            <Layout>
                <NavHeader />
                <Content className={"main-body"}>
                    <Layout>
                        <SiderMenuMain/>
                        <Content className={'main-content'}>
                            <NavBreadcrumb itemList={crumb}/>
                            <div id="mainTable">
                            </div>
                        </Content>
                    </Layout>
                </Content>
                <NavFooter/>
            </Layout>
        );
    }

    saveRecord = (record:any) => {
        if (this.state.parents.length > 1) {
            record.parent_id = this.state.parents[this.state.parents.length - 1];
        }
        console.log('save:', record);
        const callback = (suc: boolean, dat: any) => {
            if (suc) {
                console.log(suc,dat)
                message.success({content:'保存成功！',className:'message_success'});
                this.reload();
            }
        }
        AxiosUtil.AxiosRequest('/api/param/grid', {list: [record]}, callback);
    }
    deleteRecord = (record_key:string) =>{
        const callback = (suc: boolean, dat: any) => {
            if (suc) {
                console.log(suc,dat)
                message.success({content:'记录已删除成功！',className:'message_success'});
            }
        }
        AxiosUtil.AxiosRequest('/api/param/grid', {list: [{param_id:record_key,isDelete:1}]}, callback);
    }
    sortRecord = (records: any[]) =>{
        const callback = (suc: boolean, dat: any) => {
            if (suc) {
                console.log(suc,dat)
                message.success({content:'排序保存成功！',className:'message_success'});
            }
        }
        AxiosUtil.AxiosRequest('/api/param/grid', {list: records}, callback);
    }
    loadMainData = (suc: boolean, dat: any) => {
        if (suc) {
            this.setState({mainData: dat.list});
            this.renderEditableTable();
        }
    }
    renderEditableTable = () => {
        const columns = [
            {
                title: 'ID',
                key: 'param_id',
                dataIndex: 'param_id',
                width: 40,
                align: 'center' as 'center',
            },
            {
                title: '所属层级',
                key: 'parent_name',
                dataIndex: 'parent_name',
                width: 200,
            },
            {
                title: '参数名',
                key: 'param_name',
                dataIndex: 'param_name',
                width: 200,
                editor: {type: 'text', required: true}
            },
            {
                title: '参数Code',
                key: 'param_code',
                dataIndex: 'param_code',
                width: 200,
                editor: {type: 'text'}
            },
            {
                title: '备注',
                key: 'remark',
                dataIndex: 'remark',
                width: 200,
                editable: true,
                editor: {type: 'text'}
            },
            {
                title: '子项',
                key: 'next',
                dataIndex: 'param_id',
                width: 88,
                align: 'center' as 'center',
                render: (text: number) => <Button type='link'
                    onClick={() => this.reloadChildren(text)}><FolderOpenOutlined/></Button>
            },
        ];
        const exButtons=[
            <Button type='link' onClick={this.reloadParent} hidden={this.state.parents.length <= 1} key='reloadParent' ><EnterOutlined rotate={90} /> 返回上级</Button>
        ];
        const r = moment().format("X");
        ReactDOM.render(
            <EditableTable
                key={r}
                columns={columns}
                datas={this.state.mainData}
                record_key="param_id"
                saveCallback={this.saveRecord}
                deleteCallback={this.deleteRecord}
                reloadCallback={this.reload}
                sortCallback={this.sortRecord}
                exButtons={exButtons}
            />
            , document.getElementById("mainTable")
        )
    }
}


